import { render, staticRenderFns } from "./CompanySelect.vue?vue&type=template&id=56e35b7e&scoped=true&"
import script from "./CompanySelect.vue?vue&type=script&lang=ts&"
export * from "./CompanySelect.vue?vue&type=script&lang=ts&"
import style0 from "./CompanySelect.vue?vue&type=style&index=0&id=56e35b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e35b7e",
  null
  
)

export default component.exports